<template>
  <div class="community-detail-page">
    <div class="header">
      <button @click="goBack" class="back-btn">← 返回列表</button>
      <h2>{{ community.name }}</h2>
    </div>

    <div class="info-card">
      <div class="card-header">
        <h3>小区基本信息</h3>
      </div>
      <div class="card-body">
        <div class="info-grid">
          <div class="info-item">
            <label>小区ID</label>
            <span>{{ community.id }}</span>
          </div>
          <div class="info-item">
            <label>小区名称</label>
            <span>{{ community.name }}</span>
          </div>
          <div class="info-item">
            <label>跑手数量</label>
            <span>{{ community.runner_count || 0 }} 位</span>
          </div>
          <div class="info-item">
            <label>店家数量</label>
            <span>{{ community.shop_count || 0 }} 家</span>
          </div>
          <div class="info-item">
            <label>所在地区</label>
            <span>{{ community.provinceName || '' }} {{ community.cityName || '' }} {{ community.districtName || '' }}</span>
          </div>
          <div class="info-item">
            <label>详细地址</label>
            <span>{{ community.address }}</span>
          </div>
          <div class="info-item">
            <label>楼栋数</label>
            <span>{{ community.building_count || 0 }} 栋</span>
          </div>
          <div class="info-item">
            <label>当前天气</label>
            <span class="weather-type-tag">{{ getWeatherTypeName(community.weatherTypeId || community.weather_type_id) }}</span>
          </div>
          <div class="info-item">
            <label>状态</label>
            <span :class="'status status-' + community.status">{{ community.status === 1 ? '启用' : '禁用' }}</span>
          </div>
          <div class="info-item">
            <label>创建时间</label>
            <span>{{ community.created_at?.substring(0, 10) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="info-card runners-card">
      <div class="card-header">
        <h3>本小区跑手列表<span class="runner-count">共[ {{ runners.length }} ]位跑手</span></h3>
      </div>
      <div class="card-body">
        <table v-if="runners.length" class="runner-table">
          <thead>
            <tr>
              <th>跑手ID</th>
              <th>姓名</th>
              <th>手机号</th>
              <th>类型</th>
              <th>认证状态</th>
              <th>在线状态</th>
              <th>工作状态</th>
              <th>负责起止时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in runners" :key="r.id">
              <td>{{ r.id }}</td>
              <td>{{ r.name }}</td>
              <td>{{ r.phone }}</td>
              <td>{{ r.runnerTypeName }}</td>
              <td><span :class="'cert-tag cert-' + r.certStatus">{{ r.certStatusName }}</span></td>
              <td>{{ r.onlineStatusName }}</td>
              <td>{{ r.workStatusName }}</td>
              <td>{{ r.startTime || '—' }} ~ {{ r.endTime || '至今' }}</td>
              <td>
                <button class="view-runner-btn" @click="viewRunner(r)">查看</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="empty-text">暂无跑手负责该小区</div>
      </div>
    </div>

    <div class="info-card shops-card">
      <div class="card-header">
        <h3>本小区店家列表<span class="shop-count">共[ {{ shops.length }} ]家店家</span></h3>
      </div>
      <div class="card-body">
        <table v-if="shops.length" class="shop-table">
          <thead>
            <tr>
              <th>店家ID</th>
              <th>店家名称</th>
              <th>联系人</th>
              <th>联系电话</th>
              <th>地址</th>
              <th>商品数</th>
              <th>认证状态</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in shops" :key="s.id">
              <td>{{ s.id }}</td>
              <td>{{ s.name }}</td>
              <td>{{ s.contactName }}</td>
              <td>{{ s.phone }}</td>
              <td>{{ s.address }}</td>
              <td>{{ s.productCount }} 个</td>
              <td><span :class="'cert-tag cert-' + s.certStatus">{{ s.certStatusName }}</span></td>
              <td><span :class="'status status-' + s.status">{{ s.statusName }}</span></td>
              <td><button class="view-shop-btn" @click="viewShop(s)">查看</button></td>
            </tr>
          </tbody>
        </table>
        <div v-else class="empty-text">该小区暂无店家</div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getCommunityDetail, getWeatherTypeOptions, getCommunityRunners, getCommunityShops } from '@/api/communities'
import { getProvinces, getCities, getDistricts } from '@/api/regions'

export default {
  name: 'CommunityDetail',
  data() {
    return {
      communityId: null,
      community: {},
      provinceList: [],
      weatherTypeList: [],
      weatherTypeMap: {},
      runners: [],
      shops: []
    }
  },
  mounted() {
    this.communityId = this.$route.params.id
    this.loadWeatherTypes()
    this.loadCommunityDetail()
    this.loadCommunityRunners()
    this.loadCommunityShops()
  },
  methods: {
    goBack() {
      this.$router.push('/communities')
    },
    viewRunner(r) {
      this.$router.push(`/user/runners/detail/${r.id}`)
    },
    viewShop(s) {
      this.$router.push(`/user/shops/detail/${s.id}`)
    },
    async loadWeatherTypes() {
      try {
        const response = await getWeatherTypeOptions()
        if (response.code === 0) {
          this.weatherTypeList = response.data.weather_types || response.data || []
          this.weatherTypeList.forEach(wt => {
            this.weatherTypeMap[wt.id] = wt.name
          })
        }
      } catch (error) {
      }
    },
    getWeatherTypeName(id) {
      return this.weatherTypeMap[id] || '未知'
    },
    async loadCommunityDetail() {
      try {
        const response = await getCommunityDetail(this.communityId)
        if (response.code === 0) {
          this.community = {
            ...response.data,
            provinceName: '',
            cityName: '',
            districtName: ''
          }
          await this.fillRegionNames(this.community)
        }
      } catch (error) {
      }
    },
    async loadCommunityRunners() {
      try {
        const response = await getCommunityRunners(this.communityId)
        if (response.code === 0) {
          this.runners = response.data.list || []
        }
      } catch (error) {
      }
    },
    async loadCommunityShops() {
      try {
        const response = await getCommunityShops(this.communityId)
        if (response.code === 0) {
          this.shops = response.data.list || []
        }
      } catch (error) {
      }
    },
    async fillRegionNames(community) {
      try {
        const provinceId = community.provinceId || community.province_id || community.provinceCode
        const cityId = community.cityId || community.city_id || community.cityCode
        const districtId = community.districtId || community.district_id || community.districtCode

        const provinceResponse = await getProvinces()
        if (provinceResponse.code === 0 || provinceResponse.code === 200) {
          this.provinceList = provinceResponse.data || []
          const province = this.provinceList.find(p => p.id === provinceId)
          community.provinceName = province ? province.name : ''
        }

        if (provinceId && cityId) {
          const cityResponse = await getCities(provinceId)
          if (cityResponse.code === 0 || cityResponse.code === 200) {
            const city = cityResponse.data.find(c => c.id === cityId)
            community.cityName = city ? city.name : ''
          }
        }

        if (cityId && districtId) {
          const districtResponse = await getDistricts(cityId)
          if (districtResponse.code === 0 || districtResponse.code === 200) {
            const district = districtResponse.data.find(d => d.id === districtId)
            community.districtName = district ? district.name : ''
          }
        }
      } catch (error) {
      }
    }
  }
}
</script>

<style scoped>
.community-detail-page {
  padding: 20px;
}

.header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.back-btn {
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.back-btn:hover {
  background: #f5f5f5;
}

.info-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.card-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
}

.card-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.runner-count {
  margin-left: 8px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 600;
  color: #3498db;
  background: #e8f4fd;
  border-radius: 10px;
  vertical-align: middle;
}

.card-body {
  padding: 20px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  background: #fafafa;
  border-radius: 6px;
}

.info-item label {
  font-size: 13px;
  color: #999;
  margin-bottom: 5px;
}

.info-item span {
  font-size: 14px;
  color: #333;
}

.status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
}

.status-1 { background: #e8f5e9; color: #2ecc71; }
.status-0 { background: #ffebee; color: #e74c3c; }

.runners-card {
  margin-top: 20px;
}

.shops-card {
  margin-top: 20px;
}

.shop-count {
  margin-left: 8px;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 600;
  color: #e67e22;
  background: #fdf0e3;
  border-radius: 10px;
  vertical-align: middle;
}

.shop-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.shop-table th,
.shop-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.shop-table th {
  background: #fafafa;
  color: #666;
  font-weight: 600;
}

.shop-table tbody tr:hover {
  background: #fafafa;
}

.view-shop-btn {
  padding: 5px 16px;
  background: #e67e22;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s, box-shadow 0.2s;
}

.view-shop-btn:hover {
  background: #d35400;
  box-shadow: 0 2px 6px rgba(230, 126, 34, 0.35);
}

.view-shop-btn:active {
  background: #ba4a00;
}

.runner-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.runner-table th,
.runner-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.runner-table th {
  background: #fafafa;
  color: #666;
  font-weight: 600;
}

.runner-table tbody tr:hover {
  background: #fafafa;
}

.view-runner-btn {
  padding: 5px 16px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s, box-shadow 0.2s;
}

.view-runner-btn:hover {
  background: #2980b9;
  box-shadow: 0 2px 6px rgba(52, 152, 219, 0.35);
}

.view-runner-btn:active {
  background: #2471a3;
}

.cert-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
}

.cert-6 { background: #e8f5e9; color: #2ecc71; }
.cert-7 { background: #ffebee; color: #e74c3c; }
.cert-0, .cert-1, .cert-2, .cert-3, .cert-4, .cert-5 { background: #fff8e1; color: #f39c12; }

.empty-text {
  padding: 30px 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}

</style>
